import { useIsFetching, useIsMutating } from "@tanstack/react-query";
import { useEffect, useState } from "react";

/** En deçà, l'activité est trop brève pour être montrée : pas de clignotement. */
const SHOW_AFTER_MS = 300;

/**
 * Fine barre animée en haut de l'écran pendant qu'une page charge ses données
 * ou qu'un enregistrement est en cours.
 *
 * Ne compte que les requêtes SANS données encore affichées (premier chargement
 * d'une page, changement de filtre) : les rafraîchissements en arrière-plan,
 * comme le compteur de notifications, ne doivent pas l'allumer.
 */
export function TopProgressBar() {
  const loading = useIsFetching({ predicate: (q) => q.state.data === undefined });
  const saving = useIsMutating();
  const busy = loading + saving > 0;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!busy) {
      setVisible(false);
      return undefined;
    }
    const t = setTimeout(() => setVisible(true), SHOW_AFTER_MS);
    return () => clearTimeout(t);
  }, [busy]);

  if (!visible) return null;
  return (
    <div
      className="fixed inset-x-0 top-0 z-[60] h-[3px] overflow-hidden bg-primary/20"
      role="progressbar"
      aria-label="Chargement en cours"
    >
      <span className="block h-full w-2/5 animate-loader-slide bg-primary motion-reduce:w-full motion-reduce:animate-none" />
    </div>
  );
}
